import { render, staticRenderFns } from "./TabsPlan.vue?vue&type=template&id=326cfd90&"
import script from "./TabsPlan.vue?vue&type=script&lang=js&"
export * from "./TabsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports